import { updateSlideInDeck } from "../editor/deckEditor.js";
import { surfBedrockChat } from "./surfBedrockChat.js";
function slideCopy(slide, index) {
    const title = slide.layers.find((l) => l.textRole === "title")?.content?.trim();
    const subtitle = slide.layers.find((l) => l.textRole === "subtitle")?.content?.trim();
    const bullets = slide.layers
        .filter((l) => l.textRole === "bullet")
        .map((l) => l.content.trim())
        .filter(Boolean);
    const body = slide.layers
        .filter((l) => l.type === "text" && l.textRole === "body")
        .map((l) => l.content.trim())
        .filter(Boolean)
        .join("\n");
    const lines = [
        `Slide ${index + 1} layout=${slide.layout}`,
        title ? `Title: ${title}` : "",
        subtitle ? `Subtitle: ${subtitle}` : "",
        bullets.length ? `Bullets:\n${bullets.map((b) => `- ${b}`).join("\n")}` : "",
        body ? `Body:\n${body}` : "",
        slide.speakerNotes ? `Notes: ${slide.speakerNotes}` : "",
    ].filter(Boolean);
    return lines.join("\n");
}
export async function generateSlideVisualBrief(cfg, deck, slideIndex) {
    const slide = deck.slides[slideIndex];
    if (!slide)
        throw new Error("Slide index invalido");
    const ctx = deck.deckContext;
    const raw = await surfBedrockChat(cfg, {
        feature: "surf.slide.visualbrief",
        systemText: [
            "You plan ONE illustrative image for a presentation slide.",
            "NO text, numbers, charts, or data in the image.",
            "Return ONLY JSON:",
            '{"subject":"short visual subject","imageRole":"background"|"content"|"none","aspect":"16:9"|"4:3"|"1:1"}',
            "Use imageRole=content when text sits beside an image slot; background for full-bleed mood.",
        ].join(" "),
        userText: [
            ctx?.summary ? `Deck summary: ${ctx.summary}` : "",
            ctx?.themes?.length ? `Themes: ${ctx.themes.join(", ")}` : "",
            slideCopy(slide, slideIndex),
        ]
            .filter(Boolean)
            .join("\n\n"),
        maxTokens: 1024,
    });
    const parsed = JSON.parse(raw.replace(/^```json\s*/i, "").replace(/```\s*$/i, ""));
    const role = parsed.imageRole;
    const imageRole = role === "content" || role === "none" || role === "background" ? role : "background";
    return {
        subject: String(parsed.subject ?? slide.layers[0]?.content ?? "abstract concept").trim(),
        imageRole,
        aspect: parsed.aspect === "4:3" || parsed.aspect === "1:1" ? parsed.aspect : "16:9",
    };
}
export function setSlideVisualBrief(deck, slideId, brief) {
    return updateSlideInDeck(deck, slideId, (slide) => ({ ...slide, visualBrief: brief }));
}
